<div class="ay-page-main">
	<main
		class="w-full"
		[ngClass]="{ 'max-w-2xl': showAside }"
	>
		<ng-content select="ay-page-main-content"></ng-content>
	</main>

	@if (showAside) {
		<aside
			#sideBar
			[ngClass]="{ 'sticky top-0': stickyAside }"
			class="w-64 shrink-0 self-start"
		>
			<ng-content select="ay-page-main-side"></ng-content>
		</aside>
	}
</div>
